function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = function (stats, winner) {
  var players_count = stats.mod.game.state.players.length;
  var highest_count = stats.mod.game.stats.dice[2];
  // get highest count
  for (var i = 2; i <= 12; i++) {
    if (stats.mod.game.stats.dice[i] > highest_count) {
      highest_count = stats.mod.game.stats.dice[i];
    }
  }
  var player_count = stats.mod.game.state.players.length;
  var max_bar_height = player_count >= 3 ? 10 : 12;

  // height for 1 count;
  var base_height = max_bar_height / highest_count;
  var html = "\n      <div class=\"settlers-stats-overlay saitoa";
  if (winner) {
    //html += ` winner`;
  }
  html += "\">\n      \t<div class=\"stats-header\">\n      \t\t<div class=\"overlay-tab active-tab\" id=\"overview-tab\">Overview</div>\n      \t\t<div class=\"overlay-tab\" id=\"resource1-tab\">Res. I</div>\n      \t\t<div class=\"overlay-tab\" id=\"resource2-tab\">Res. II</div>\n      \t\t<div class=\"overlay-tab\" id=\"timeline-tab\">Timeline</div>\n      \t</div>\n      \t<div class=\"overlay-page active-page\" id=\"overview-page\">\n      ";
  if (winner) {
    html += "<h1>".concat(winner, " wins!</h1>");
  }

  //Fucking Dice
  html += "<div class=\"settlers-state-container\">\n<!--                  <div class=\"settlers-stats-player\">Dice Rolls</div> -->\n        ";
  html += "<div class=\"settlers-dice-histogram\" title=\"number of times each number has been rolled\">";
  for (var _i = 2; _i <= 12; _i++) {
    var bar_height = base_height * stats.mod.game.stats.dice[_i];
    html += "  <div class=\"settlers-dice-bar dice-".concat(_i, " ").concat(stats.mod.game.stats.dice[_i] > 0 ? 'has_been_rolled' : 'never_rolled', "\" data-dice-rolls=\"").concat(_i, "\" style=\"height:").concat(bar_height, "rem;\">\n                      <div class=\"settlers-dice-count\">").concat(stats.mod.game.stats.dice[_i], "</div>");
    for (var j = 0; j < players_count; j++) {
      var player_bar_height = base_height * stats.mod.game.stats.dicePlayer[_i][j];
      html += "<div class=\"settlers-dice-count-player p".concat(stats.mod.game.colors[j], "\" style=\"height:").concat(player_bar_height, "rem;\"></div>");
    }
    html += '</div>';
  }
  html += "</div>";
  html += "<div class=\"settlers-dice-numbers\" title=\"dice roll\">";
  for (var _i2 = 2; _i2 <= 12; _i2++) {
    html += "<div class=\"settlers-dice-number\">".concat(_i2, "</div>");
  }
  html += "</div><div class=\"settlers-dice-numbers\" title=\"rolls since number last came up\">";
  for (var _i3 = 2; _i3 <= 12; _i3++) {
    if (stats.mod.game.stats.famine[_i3] !== undefined) {
      html += "<div class=\"settlers-number\">".concat(stats.mod.game.stats.famine[_i3], "</div>");
    } else {
      html += "<div class=\"settlers-number\"></div>";
    }
  }
  html += "</div><hr></div>";

  //
  //Scoring
  //
  html += "<div class=\"settlers-state-container\">\n\t\t\t\t\t\t <div class=\"settlers-stats-row\">\n             \t<div class=\"settlers-stats-player\">Scoring</div>\n              <div class=\"settlers-stats-vp\" title=\"Village\">\n                <img src=\"/settlers/img/icons/village.png\">\n              </div>\n              <div class=\"settlers-stats-vp title=\"City\">\n              \t<img src=\"/settlers/img/icons/city.png\">\n              \t<div class=\"settlers-stats-multiplier\">&times;2</div>\n              </div>\n\t\t\t\t\t\t\t<div class=\"settlers-stats-vp\" title=\"Victory Point Card\">\n\t\t\t\t\t\t\t\t".concat(stats.mod.vp.img, "\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"settlers-stats-vp\" title=\"Longest Road\">\n\t\t\t\t\t\t\t\t").concat(stats.mod.longest.icon, "\n\t\t\t\t\t\t\t\t<div class=\"settlers-stats-vp-count\">").concat(Math.max(stats.mod.longest.min, stats.mod.game.state.longestRoad.size), "</div>\n\t\t\t\t\t\t\t\t<div class=\"settlers-stats-multiplier\">+").concat(stats.mod.longest.value, "</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"settlers-stats-vp\" title=\"Largest Army\">\n\t\t\t\t\t\t\t\t").concat(stats.mod.s.img, "\n\t\t\t\t\t\t\t\t<div class=\"settlers-stats-vp-count\">").concat(Math.max(3, stats.mod.game.state.largestArmy.size), "</div>\n\t\t\t\t\t\t\t\t<div class=\"settlers-stats-multiplier\">+").concat(stats.mod.largest.value, "</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div></div>\n\t\t\t\t\t\t</div>\n\t\t");
  for (var _i4 = 0; _i4 < stats.mod.game.players.length; _i4++) {
    var numVil = 0;
    var numCity = 0;
    for (var _j = 0; _j < stats.mod.game.state.cities.length; _j++) {
      if (stats.mod.game.state.cities[_j].player === _i4 + 1) {
        if (stats.mod.game.state.cities[_j].level == 1) {
          numVil++;
        } else {
          numCity++;
        }
      }
    }
    html += "\n\t\t <div class=\"settlers-stats-row\">\n      \t<div class=\"settlers-stats-player p".concat(stats.mod.game.colors[_i4], "\">").concat(stats.mod.game.playerNames[_i4], "</div>\n\t\t\t\t<div class=\"settlers-stat-num\">").concat(numVil, "</div>");
    if (numCity > 0) {
      html += "<div class=\"settlers-stat-num\">".concat(numCity, "</div>");
    } else {
      html += "<div class=\"settlers-stat-num\"></div>";
    }
    if (stats.mod.game.state.players[_i4].vpc > 0) {
      html += "<div class=\"settlers-stat-num\">".concat(stats.mod.game.state.players[_i4].vpc, "</div>");
    } else {
      html += "<div class=\"settlers-stat-num\"></div>";
    }
    if (stats.mod.game.state.longestRoad.player == _i4 + 1) {
      html += "<div class=\"settlers-stat-num\"><i class=\"fa-solid fa-check\"></i></div>";
    } else {
      html += "<div class=\"settlers-stat-num\"></div>";
    }
    if (stats.mod.game.state.largestArmy.player == _i4 + 1) {
      html += "<div class=\"settlers-stat-num\"><i class=\"fa-solid fa-check\"></i></div>";
    } else {
      html += "<div class=\"settlers-stat-num\"></div>";
    }
    html += "<div class=\"settlers-stat-num\">".concat(stats.mod.game.state.players[_i4].vp, "</div></div>");
  }
  html += "<hr></div> <div class=\"settlers-state-container\">\n\t\t\t    \t<div class=\"settlers-hist-row\">\n\t\t\t    \t\t<div></div>";
  for (var _i5 = 0; _i5 < stats.mod.game.players.length; _i5++) {
    html += "<div class=\"settlers-stats-player p".concat(stats.mod.game.colors[_i5], "\">").concat(stats.mod.game.playerNames[_i5], "</div>");
  }
  html += '</div>';
  var player_array = Array(stats.mod.game.players.length);
  player_array.fill(0);
  for (var _j2 = 0; _j2 < stats.mod.game.stats.history.length; _j2++) {
    var _iterator = _createForOfIteratorHelper(stats.mod.game.stats.history[_j2].threatened),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _i6 = _step.value;
        player_array[_i6 - 1]++;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  html += "<div class=\"settlers-hist-row\">\n  \t<div class=\"settlers-stats-vp title=\"Rolls blocked by Bandit/Robber\">\n\t  \t<img src=\"/settlers/img/icons/bandit.png\">\n\t  \t<div class=\"settlers-stats-vp-count\">%</div>\n  \t</div>";
  for (var _i7 = 0, _player_array = player_array; _i7 < _player_array.length; _i7++) {
    var _i8 = _player_array[_i7];
    html += "<div class=\"settlers-stat-num\">".concat(Math.round(1000 * _i8 / stats.mod.game.stats.history.length) / 10 || '0', "</div>");
  }
  html += "</div>";
  html += "<div class=\"settlers-hist-row\">\n  \t<div class=\"settlers-stats-vp title=\"Times moved Bandit/Robber\">\n\t  \t<img src=\"/settlers/img/icons/bandit.png\">\n\t  \t<div class=\"settlers-stats-vp-count\">-></div>\n  \t</div>";
  var _iterator2 = _createForOfIteratorHelper(stats.mod.game.stats.move_bandit),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _i15 = _step2.value;
      html += "<div class=\"settlers-stat-num\">".concat(_i15, "</div>");
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  html += "</div></div></div>";

  //
  //Production Log
  //

  html += "<div class=\"overlay-page\" id=\"resource1-page\">";
  html += "<div class=\"settlers-state-container\">";
  html += " <div class=\"settlers-stats-row\"><div class=\"settlers-stats-player hover-hint\" title=\"Resources produced by dice rolls\">Production</div>";
  for (var r in stats.mod.game.stats.production) {
    html += "\t<div class=\"settlers-stats-card\">\n\t\t\t\t\t\t\t\t<img src=\"/settlers/img/cards/".concat(r, ".png\">\n\t\t\t\t\t\t\t</div>\n\t\t");
  }
  html += "<div></div></div>";
  for (var _i9 = 0; _i9 < stats.mod.game.players.length; _i9++) {
    var total = 0;
    html += "<div class=\"settlers-stats-row\">\n\t\t\t\t\t\t\t\t<div class=\"settlers-stats-player p".concat(stats.mod.game.colors[_i9], "\">").concat(stats.mod.game.playerNames[_i9], "</div>");
    for (var _r in stats.mod.game.stats.production) {
      total += stats.mod.game.stats.production[_r][_i9];
      if (stats.mod.game.stats.production[_r][_i9] > 0) {
        html += "<div class=\"settlers-stat-num\">".concat(stats.mod.game.stats.production[_r][_i9], "</div>");
      } else {
        html += "<div class=\"settlers-stat-num\"></div>";
      }
    }
    html += "<div class=\"settlers-stat-num\">".concat(total, "</div></div>");
  }
  html += "<hr></div>";

  //
  // Losses
  //
  html += "<div class=\"settlers-state-container\">";
  html += " <div class=\"settlers-stats-row\"><div class=\"settlers-stats-player hover-hint\" title=\"Cards discarded or stolen by robber\">Stolen</div>";
  for (var _r2 in stats.mod.game.stats.production) {
    html += "\t<div class=\"settlers-stats-card\">\n\t\t\t\t\t\t\t\t<img src=\"/settlers/img/cards/".concat(_r2, ".png\">\n\t\t\t\t\t\t\t</div>\n\t\t");
  }
  html += "<div></div></div>";
  for (var _i0 = 0; _i0 < stats.mod.game.players.length; _i0++) {
    var _total = 0;
    html += "<div class=\"settlers-stats-row\">\n\t\t\t\t\t\t\t\t<div class=\"settlers-stats-player p".concat(stats.mod.game.colors[_i0], "\">").concat(stats.mod.game.playerNames[_i0], "</div>");
    for (var _r3 in stats.mod.game.stats.production) {
      var sum = stats.mod.game.stats.robbed[_r3][_i0];
      _total += sum;
      if (sum > 0) {
        html += "<div class=\"settlers-stat-num\">-".concat(sum, "</div>");
      } else {
        html += "<div class=\"settlers-stat-num\"></div>";
      }
    }
    html += "<div class=\"settlers-stat-num\">".concat(_total > 0 ? "-".concat(_total) : '', "</div></div>");
  }
  html += '<hr></div>';

  //
  // Non-production
  //
  html += "<div class=\"settlers-state-container\">";
  html += " <div class=\"settlers-stats-row\"><div class=\"settlers-stats-player hover-hint\" title=\"Resources blocked by presence of bandit\">Blocked</div>";
  for (var _r4 in stats.mod.game.stats.production) {
    html += "\t<div class=\"settlers-stats-card no-vp\">\n\t\t\t\t\t\t\t\t<img src=\"/settlers/img/cards/".concat(_r4, ".png\">\n\t\t\t\t\t\t\t</div>\n\t\t");
  }
  html += "<div></div></div>";
  for (var _i1 = 0; _i1 < stats.mod.game.players.length; _i1++) {
    var _total2 = 0;
    html += "<div class=\"settlers-stats-row\">\n\t\t\t\t\t\t\t\t<div class=\"settlers-stats-player p".concat(stats.mod.game.colors[_i1], "\">").concat(stats.mod.game.playerNames[_i1], "</div>");
    for (var _r5 in stats.mod.game.stats.production) {
      if (stats.mod.game.stats.blocked[_r5][_i1] > 0) {
        _total2 += stats.mod.game.stats.blocked[_r5][_i1];
        html += "<div class=\"settlers-stat-num\">".concat(stats.mod.game.stats.blocked[_r5][_i1], "</div>");
      } else {
        html += "<div class=\"settlers-stat-num\"></div>";
      }
    }
    html += "<div class=\"settlers-stat-num\">".concat(_total2 > 0 ? "".concat(_total2) : '', "</div></div>");
  }
  html += '</div></div>';

  //
  // Page 2
  //
  html += "<div class=\"overlay-page\" id=\"resource2-page\">";
  html += "<div class=\"settlers-state-container\">";
  html += " <div class=\"settlers-stats-row\"><div class=\"settlers-stats-player hover-hint\" title=\"Resources discarded on 7\">Discarded</div>";
  for (var _r6 in stats.mod.game.stats.production) {
    html += "\t<div class=\"settlers-stats-card\">\n\t\t\t\t\t\t\t\t<img src=\"/settlers/img/cards/".concat(_r6, ".png\">\n\t\t\t\t\t\t\t</div>\n\t\t");
  }
  html += "<div></div></div>";
  for (var _i10 = 0; _i10 < stats.mod.game.players.length; _i10++) {
    var _total3 = 0;
    html += "<div class=\"settlers-stats-row\">\n\t\t\t\t\t\t\t\t<div class=\"settlers-stats-player p".concat(stats.mod.game.colors[_i10], "\">").concat(stats.mod.game.playerNames[_i10], "</div>");
    for (var _r7 in stats.mod.game.stats.production) {
      var _sum = stats.mod.game.stats.discarded[_r7][_i10];
      _total3 += _sum;
      if (_sum > 0) {
        html += "<div class=\"settlers-stat-num\">-".concat(_sum, "</div>");
      } else {
        html += "<div class=\"settlers-stat-num\"></div>";
      }
    }
    html += "<div class=\"settlers-stat-num\">".concat(_total3 > 0 ? "".concat(_total3) : '', "</div></div>");
  }
  html += "<hr></div>";

  //
  // Trades, pt 1
  //
  html += "<div class=\"settlers-state-container\">";
  html += " <div class=\"settlers-stats-row\"><div class=\"settlers-stats-player hover-hint\" title=\"Cards traded to bank/port\">Traded out</div>";
  for (var _r8 in stats.mod.game.stats.production) {
    html += "\t<div class=\"settlers-stats-card\">\n\t\t\t\t\t\t\t\t<img src=\"/settlers/img/cards/".concat(_r8, ".png\">\n\t\t\t\t\t\t\t</div>\n\t\t");
  }
  html += "<div></div></div>";
  for (var _i11 = 0; _i11 < stats.mod.game.players.length; _i11++) {
    var _total4 = 0;
    html += "<div class=\"settlers-stats-row\">\n\t\t\t\t\t\t\t\t<div class=\"settlers-stats-player p".concat(stats.mod.game.colors[_i11], "\">").concat(stats.mod.game.playerNames[_i11], "</div>");
    for (var _r9 in stats.mod.game.stats.production) {
      if (stats.mod.game.stats.banked[_r9][_i11] > 0) {
        _total4 += stats.mod.game.stats.banked[_r9][_i11];
        html += "<div class=\"settlers-stat-num\">".concat(stats.mod.game.stats.banked[_r9][_i11], "</div>");
      } else {
        html += "<div class=\"settlers-stat-num\"></div>";
      }
    }
    html += "<div class=\"settlers-stat-num\">".concat(_total4 > 0 ? "-".concat(_total4) : '', "</div></div>");
  }
  html += '<hr></div>';

  //
  // Trades, pt 2
  //
  html += "<div class=\"settlers-state-container\">";
  html += " <div class=\"settlers-stats-row\"><div class=\"settlers-stats-player hover-hint\" title=\"Cards received from bank/port\">Traded in</div>";
  for (var _r0 in stats.mod.game.stats.production) {
    html += "\t<div class=\"settlers-stats-card no-vp\">\n\t\t\t\t\t\t\t\t<img src=\"/settlers/img/cards/".concat(_r0, ".png\">\n\t\t\t\t\t\t\t</div>\n\t\t");
  }
  html += "<div></div></div>";
  for (var _i12 = 0; _i12 < stats.mod.game.players.length; _i12++) {
    var _total5 = 0;
    html += "<div class=\"settlers-stats-row\">\n\t\t\t\t\t\t\t\t<div class=\"settlers-stats-player p".concat(stats.mod.game.colors[_i12], "\">").concat(stats.mod.game.playerNames[_i12], "</div>");
    for (var _r1 in stats.mod.game.stats.production) {
      if (stats.mod.game.stats.traded[_r1][_i12] > 0) {
        _total5 += stats.mod.game.stats.traded[_r1][_i12];
        html += "<div class=\"settlers-stat-num\">".concat(stats.mod.game.stats.traded[_r1][_i12], "</div>");
      } else {
        html += "<div class=\"settlers-stat-num\"></div>";
      }
    }
    html += "<div class=\"settlers-stat-num\">".concat(_total5 > 0 ? "".concat(_total5) : '', "</div></div>");
  }
  html += '</div>';

  // Timeline

  html += "</div>\n\t\t<div class=\"overlay-page\" id=\"timeline-page\">";
  html += "<div class=\"settlers-hist-container hide-scrollbar\">\n    \t<div class=\"settlers-hist-row\">\n    \t\t<div class=\"settlers-timeline-turn-lables\"><div>Turn</div><div>Roll</div></div>";
  for (var _i13 = 0; _i13 < stats.mod.game.players.length; _i13++) {
    html += "<div class=\"settlers-stats-player p".concat(stats.mod.game.colors[_i13], "\">").concat(stats.mod.game.playerNames[_i13], "</div>");
  }
  html += '</div>';
  for (var _j3 = stats.mod.game.stats.history.length - 1; _j3 >= 0; _j3--) {
    html += "<div class=\"settlers-hist-row".concat(stats.mod.game.stats.history[_j3].roll == 7 ? ' robber' : '', "\">\n\t\t\t\t\t\t<div class=\"roll\">\n\t\t\t\t\t\t\t<span>").concat(_j3 + 1, ": </span>\n\t\t\t\t\t\t\t<span>").concat(stats.mod.game.stats.history[_j3].roll, "</span>\n\t\t\t\t\t\t</div>");
    for (var _i14 = 1; _i14 <= stats.mod.game.players.length; _i14++) {
      var _stats$mod$game$stats, _stats$mod$game$stats2;
      html += "<div class=\"hist-cards\">";
      if ((_stats$mod$game$stats = stats.mod.game.stats.history[_j3]) !== null && _stats$mod$game$stats !== void 0 && _stats$mod$game$stats.harvest[_i14]) {
        var res = stats.mod.game.stats.history[_j3].harvest[_i14].sort();
        var _iterator3 = _createForOfIteratorHelper(res),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _r10 = _step3.value;
            html += "<div class=\"settlers-stats-card\">\n\t\t\t\t\t\t\t\t\t\t\t\t<img src=\"/settlers/img/cards/".concat(_r10, ".png\">\n\t\t\t\t\t\t\t\t\t\t\t</div>");
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
      if ((_stats$mod$game$stats2 = stats.mod.game.stats.history[_j3]) !== null && _stats$mod$game$stats2 !== void 0 && _stats$mod$game$stats2.bandit[_i14]) {
        var _res = stats.mod.game.stats.history[_j3].bandit[_i14].sort();
        var _iterator4 = _createForOfIteratorHelper(_res),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _r11 = _step4.value;
            html += "<div class=\"settlers-stats-card no-vp\">\n\t\t\t\t\t\t\t\t\t\t\t\t<img src=\"/settlers/img/cards/".concat(_r11, ".png\">\n\t\t\t\t\t\t\t\t\t\t\t</div>");
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
      html += '</div>';
    }
    html += '</div>';
  }
  html += "</div>";
  return html + '</div>';
};